import { handle } from 'redux-pack';
import { assoc, assocPath, mapObjIndexed, pick, values, flatten, groupBy, uniq } from 'ramda';
import { get } from 'lib/communication';

// import { get } from 'lib/communication';
import createReducer from 'lib/createReducer';
// import testdata from './testdata.json';
import moment from 'moment';
// import { formatDate } from 'lib/dateDisplay';

/* Action types */

const LOAD = 'myms/floodlight/LOAD';
const SYNC = 'myms/floodlight/SYNC';

export const actionTypes = { LOAD, SYNC };

/* Action creator(s) */

const loadFloodlight = () => ({
  type: LOAD,
  promise: get('/floodlight/data'),
});

const requestFloodlightSync = () => ({
  type: SYNC,
  promise: get('/floodlight/sync').then(() => get('/floodlight/data')),
});

export const actions = { loadFloodlight, requestFloodlightSync };

/* Handlers and the reducer */

const initialState = {
  isLoading: false,
  error: null,
  isLinked: null,
  latest: null,
  groups: {},
};

const symptomLabelMap = {
  'symptoms_tracker.bowel_and_bladder': 'B&B',
  'symptoms_tracker.hand_and_arm': 'H&A',
  'symptoms_tracker.lower_extremities': 'LE',
  'symptoms_tracker.mind': 'M',
  'symptoms_tracker.walking': 'W',
};

const processPayload = payload => state => {
  if (!payload.isLinked) {
    return { ...state, isLinked: false };
  }
  if (!payload.data) {
    return { ...state, error: 'No data array provided' };
  }

  const data = payload.data.reduce(
    (acc, d) => {
      const accessor = `${d.testName}.${d.featureName}${d.handUsed ? `.${d.handUsed}` : ''}`;
      const dp = { date: new Date(d.eventTimestamp), value: d.value };
      const newLatest = Math.max(acc.latest, dp.date);
      const groups = { ...acc.groups };
      if (groups[accessor]) {
        groups[accessor] = [...groups[accessor], dp];
      } else {
        groups[accessor] = [dp];
      }
      return { latest: new Date(newLatest), groups };
    },
    { latest: null, groups: {} },
  );

  const symptomGroups = pick(
    [
      'symptoms_tracker.bowel_and_bladder',
      'symptoms_tracker.hand_and_arm',
      'symptoms_tracker.lower_extremities',
      'symptoms_tracker.mind',
      'symptoms_tracker.walking',
    ],
    data.groups,
  );

  const mappedSymptoms = mapObjIndexed(
    (val, key) => val.map(v => ({ ...v, value: symptomLabelMap[key] })),
    symptomGroups,
  );

  const oneToOneSymptoms = flatten(values(mappedSymptoms));

  const symptomsGroupedByDay = groupBy(a => moment(a.date).format('YYYY-MM-DD'), oneToOneSymptoms);

  const oneToManySymptoms = values(
    mapObjIndexed(
      (val, key) => ({ date: moment(key, 'YYYY-MM-DD'), value: uniq(val.map(v => v.value)) }),
      symptomsGroupedByDay,
    ),
  );

  if (oneToOneSymptoms && oneToOneSymptoms.length > 0) {
    data.groups['symptoms_tracker.overview'] = oneToManySymptoms;
  }

  return { ...state, isLinked: true, ...data };
};

const handleLoadData = (s, a) =>
  handle(s, a, {
    start: assocPath(['isLoading'], true),
    finish: assocPath(['isLoading'], false),
    failure: assoc('error', a.payload),
    success: processPayload(a.payload),
  });

export default createReducer(initialState, {
  [LOAD]: handleLoadData,
  [SYNC]: handleLoadData,
});
